import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const diningOptionApi = createApi({
  reducerPath: "diningOptionApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["DiningOptions"],
  endpoints: (builder) => ({
    getDiningOptionList: builder.query({
      query: ({ id, subDomain }) => {
        return {
          url: `/dining-option/${id}/list`,
          method: "GET",
          params: { subdomain: subDomain },
        };
      },
      transformResponse: (response) =>
        response.sort((a, b) => a.order - b.order),
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "DiningOptions", id })),
              { type: "DiningOptions", id: "LIST" },
            ]
          : [{ type: "DiningOptions", id: "LIST" }];
      },
    }),
    createDiningOption: builder.mutation({
      query: ({ subdomain, data }) => {
        return {
          url: `/dining-option/create`,
          method: "POST",
          body: { ...data, subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "DiningOptions", id: "LIST" }],
    }),
    updateDiningOption: builder.mutation({
      query: ({ id, stationId, subdomain, data }) => {
        return {
          url: `/dining-option/${stationId}/${id}`,
          method: "PATCH",
          body: { ...data },
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "DiningOptions", id: "LIST" }],
    }),
    deleteDiningOption: builder.mutation({
      query: ({ id, stationId, subdomain }) => {
        return {
          url: `/dining-option/${stationId}/${id}`,
          method: "DELETE",
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "DiningOptions", id: "LIST" }],
    }),
    saveDiningOptionsOrder: builder.mutation({
      query: ({ subDomain, payload, stationId }) => {
        return {
          url: `/dining-option/update-list`,
          method: "POST",
          body: {
            options: payload,
            subdomain: subDomain,
            station_id: stationId
          },
        };
      },
      invalidatesTags: [{ type: "DiningOptions", id: "LIST" }],
    }),
  }),
});

export const {
  useLazyGetDiningOptionListQuery,
  useGetDiningOptionListQuery,
  useCreateDiningOptionMutation,
  useUpdateDiningOptionMutation,
  useDeleteDiningOptionMutation,
  useSaveDiningOptionsOrderMutation,
} = diningOptionApi;
